package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.tedd.db.Focus_session
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

/**
 * Sessions Pomodoro. Une session = un cycle démarrage → end_session.
 * Enregistrée seulement si elle a contenu au moins 1 pomodoro complet ou des minutes de focus.
 */
class FocusSessionRepository(private val db: TeddDatabase) {

    fun observeAll(): Flow<List<Focus_session>> =
        db.focusSessionQueries.selectAll().asFlow().mapToList(Dispatchers.Default)

    fun observeBetween(fromMillis: Long, toMillis: Long): Flow<List<Focus_session>> =
        db.focusSessionQueries.selectBetween(fromMillis, toMillis).asFlow().mapToList(Dispatchers.Default)

    suspend fun record(
        startedAt: Long,
        endedAt: Long,
        focusMinutes: Long,
        breakMinutes: Long,
        pomodoros: Long,
        taskId: String?,
        note: String? = null,
        skillId: String? = null,
        id: String = newId("fs"),
    ): String = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.focusSessionQueries.insertWithNote(
            id, startedAt, endedAt, focusMinutes, breakMinutes, pomodoros, taskId, note, skillId, now, now,
        )
        id
    }

    /** Phrase de fin de course, écrite après coup. */
    suspend fun setNote(id: String, note: String?) = withContext(Dispatchers.Default) {
        db.focusSessionQueries.updateNote(note?.takeIf { it.isNotBlank() }, nowMillis(), id)
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.focusSessionQueries.softDelete(now, now, id)
    }
}
